import React, { useState, useEffect } from "react";
import snsWebSdk from "@sumsub/websdk";
import { baseUrl } from "../../../enum/constant";

const VerificationComponent = ({ updateStatus }) => {
    const [accessToken, setAccessToken] = useState(null);
    const [applicantId, setApplicantId] = useState(null);
    const [status, setStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isVerificationStarted, setIsVerificationStarted] = useState(false);
    const origin = window.origin;

    useEffect(() => {
        // Automatically start the verification process when the component is mounted
        createApplicant();
    }, []); // Empty dependency array ensures this runs only once, when the component is mounted

    const createApplicant = () => {
        setIsLoading(true);
        setIsVerificationStarted(true);
        const base = baseUrl;

        fetch(base + "api/create-applicant",
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                }
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setAccessToken(data.accessToken);
                setApplicantId(data.applicantId);
                launchWebSdk(data.accessToken, data.applicantId);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching accessToken and applicantId:", error);
                setIsLoading(false);
            });
    };

    const launchWebSdk = (accessToken, applicantId) => {
        if (!accessToken || !applicantId) {
            console.error("Access token or applicant ID is missing");
            return;
        }

        const snsWebSdkInstance = snsWebSdk
            .init(accessToken, () => Promise.resolve(accessToken))
            .withConf({
                lang: "en",
                theme: "dark",
            })
            .withOptions({ addViewportTag: false, adaptIframeHeight: true })
            .on("idCheck.onStepCompleted", (payload) => {
                console.log("onStepCompleted", payload);
            })
            .on("idCheck.onError", (error) => {
                console.log("onError", error);
            })
            .on("idCheck.onVerificationCompleted", (payload) => {
                console.log("Verification Completed", payload);
                setStatus("Completed");
                // Send status update to backend, then redirect
                updateApplicantStatus(payload.applicantId, "Completed")
                    .then(() => {
                        updateStatus(true);
                        // Redirect after successful update
                        window.location.href = origin;
                    })
                    .catch((error) => {
                        console.error("Error during status update or redirect:", error);
                    });
            })
            .build();

        snsWebSdkInstance.launch("#sumsub-websdk-container");
    };

    const updateApplicantStatus = (applicantId, status) => {
        const base = baseUrl;
        fetch(base + "api/update-applicant-status", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                applicantId: applicantId,
                status: status,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                console.log("Status updated", data);
            })
            .catch((error) => {
                console.error("Error updating status:", error);
            });
    };
    return (
        <div>
            <div id="sumsub-websdk-container"></div>
            {!isVerificationStarted && (
                <p style={{ textAlign: "right" }}>
                    <button
                        id="start-button"
                        className="element-button"
                        onClick={createApplicant}
                        disabled={isLoading}
                    >
                        {isLoading ? "Creating Applicant..." : "Start verification"}
                    </button>
                </p>
            )}

            {status && (
                <div
                    id="verification-status"
                    style={{ textAlign: "center", marginTop: "20px" }}
                >
                    Status: {status}
                </div>
            )}
        </div>
    );
}

export default VerificationComponent;